/**
 * @typedef {Object} LoginInfo
 * @property {string} token
 * @property {string} userId
 * @property {string} userName
 * @property {string} role
 * @property {string} userNumber
 * @property {number|null} jobLevel
 */



export const loginMixin = {
  methods: {
    /** @param {LoginInfo} loginInfo*/
    setLoginInfo(loginInfo) {
      // Store in Vuex store (which also handles localStorage)
      this.$store.dispatch('user/setCurrentUser', {
        id: loginInfo.userId ? Number(loginInfo.userId) : null,
        name: loginInfo.userName,
        number: loginInfo.userNumber,
        role: loginInfo.role,
        jobLevel: loginInfo.jobLevel,
        token: loginInfo.token
      });
    },

  }
}